import { baseApi } from "./api/baseApi";
import { configureStore } from "@reduxjs/toolkit";
import timezoneReducer from "./features/timezone/timezoneSlice";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    timezone: timezoneReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
